(() => {
  const root = document.querySelector("[data-nappi-offer]");
  const funnel = window.NappiFunnel || {};
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (root) {
    const inputs = [...root.querySelectorAll('[data-offer-packs] input[type="radio"]')];
    const links = root.querySelectorAll("[data-offer-link]");
    const regulars = root.querySelectorAll("[data-offer-regular]");
    const sales = root.querySelectorAll("[data-offer-sale]");
    const builderUrl = (pairs) => funnel.stepUrl ? funnel.stepUrl("builder", { quantity: pairs }) : `${window.location.pathname}?view=builder&quantity=${pairs}`;
    const apply = () => {
      const input = inputs.find((item) => item.checked) || inputs[0];
      if (!input) return;
      inputs.forEach((item) => item.closest(".nappi-offer__pack")?.classList.toggle("is-selected", item === input));
      const saving = Number(input.dataset.saving) > 0;
      const regularLabel = root.dataset.regularLabel || "";
      regulars.forEach((el) => {
        el.textContent = "";
        if (!saving) return;
        const label = document.createElement("span");
        label.className = "nappi-vh";
        label.textContent = regularLabel;
        el.append(label, input.dataset.regular);
      });
      sales.forEach((el) => {
        el.textContent = input.dataset.sale;
      });
      const href = builderUrl(input.value);
      links.forEach((link) => link.setAttribute("href", href));
    };
    const restored = inputs.find((item) => item.checked && !item.defaultChecked);
    if (!restored) {
      const wanted = new URLSearchParams(window.location.search).get("pack");
      const target = inputs.find((item) => item.value === wanted) || inputs.find((item) => item.value === root.dataset.defaultPack);
      if (target) target.checked = true;
    }
    inputs.forEach((item) => item.addEventListener("change", apply));
    apply();
    window.addEventListener("pageshow", apply);
    const pixel = (name, params) => window.NappiTrack ? window.NappiTrack(name, params) : (window.__nappiTrackQ = window.__nappiTrackQ || []).push([name, params]);
    const packParams = () => {
      const input = inputs.find((item) => item.checked) || inputs[0];
      const pairs = Number(input?.value) || 0;
      const cents = funnel.tier ? funnel.tier(pairs)?.saleCents : null;
      const params = { content_name: `pack-${pairs}`, num_items: pairs };
      if (typeof cents === "number") {
        params.value = Math.round(cents) / 100;
        params.currency = window.Shopify?.currency?.active || "USD";
      }
      return params;
    };
    pixel("OfferView", packParams());
    inputs.forEach((item) => item.addEventListener("change", () => pixel("PackSelected", packParams())));
    links.forEach((link) => link.addEventListener("click", () => pixel("OfferCTA", packParams())));
    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports("speculationrules")) {
      const rules = document.createElement("script");
      rules.type = "speculationrules";
      rules.textContent = JSON.stringify({
        prefetch: [{ source: "document", where: { selector_matches: "a[data-offer-link]" }, eagerness: "moderate" }]
      });
      document.head.append(rules);
    }
    root.querySelectorAll("[data-offer-rating]").forEach((rating) => {
      const toggle = rating.querySelector("[data-rating-toggle]");
      const pop = rating.querySelector("[data-rating-pop]");
      if (!toggle || !pop) return;
      const setOpen = (open) => {
        pop.hidden = !open;
        toggle.setAttribute("aria-expanded", String(open));
      };
      toggle.addEventListener("click", () => setOpen(pop.hidden));
      pop.querySelector("[data-rating-all]")?.addEventListener("click", () => setOpen(false));
      document.addEventListener("click", (event) => {
        if (!pop.hidden && !rating.contains(event.target)) setOpen(false);
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !pop.hidden) {
          setOpen(false);
          toggle.focus();
        }
      });
    });
    root.querySelectorAll("[data-offer-gallery]").forEach((gallery) => {
      const track = gallery.querySelector("[data-gallery-track]");
      const slides = gallery.querySelectorAll("[data-gallery-slide]");
      const prev = gallery.querySelector("[data-gallery-prev]");
      const next = gallery.querySelector("[data-gallery-next]");
      const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      if (!track || !slides.length) return;
      let index = 0;
      const show = (current) => {
        index = current;
        prev?.setAttribute("aria-disabled", String(current <= 0));
        next?.setAttribute("aria-disabled", String(current >= slides.length - 1));
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle("is-active", i === current);
          if (i === current) thumb.setAttribute("aria-current", "true");
          else thumb.removeAttribute("aria-current");
        });
      };
      const goTo = (target) => {
        const i = Math.max(0, Math.min(slides.length - 1, target));
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion.matches ? "auto" : "smooth" });
        show(i);
      };
      track.addEventListener(
        "scroll",
        () => {
          const current = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (current !== index) show(current);
        },
        { passive: true }
      );
      prev?.addEventListener("click", () => {
        if (prev.getAttribute("aria-disabled") !== "true") goTo(index - 1);
      });
      next?.addEventListener("click", () => {
        if (next.getAttribute("aria-disabled") !== "true") goTo(index + 1);
      });
      thumbs.forEach((thumb) => thumb.addEventListener("click", () => goTo(Number(thumb.dataset.galleryThumb))));
      const thumbVideos = [...gallery.querySelectorAll("[data-thumb-video]")];
      if (thumbVideos.length && !reduceMotion.matches && !navigator.connection?.saveData) {
        const start = () => {
          thumbVideos.forEach((video) => {
            video.addEventListener("playing", () => video.classList.add("is-playing"), { once: true });
            video.src = video.dataset.thumbVideo;
            video.play().catch(() => {
            });
          });
        };
        const later = () => "requestIdleCallback" in window ? window.requestIdleCallback(start, { timeout: 2500 }) : window.setTimeout(start, 1200);
        if (document.readyState === "complete") later();
        else window.addEventListener("load", later, { once: true });
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState !== "visible") return;
          thumbVideos.forEach((video) => {
            if (video.src && video.paused) video.play().catch(() => {
            });
          });
        });
      }
      window.addEventListener("resize", () => {
        track.scrollTo({ left: index * track.clientWidth, behavior: "instant" });
      });
      let drag = null;
      track.addEventListener("pointerdown", (event) => {
        if (event.pointerType !== "mouse" || event.button !== 0) return;
        drag = { x: event.clientX, left: track.scrollLeft, start: index, moved: false };
        try {
          track.setPointerCapture(event.pointerId);
        } catch (error) {
        }
      });
      track.addEventListener("pointermove", (event) => {
        if (!drag) return;
        const dx = event.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) < 4) return;
        drag.moved = true;
        track.classList.add("is-dragging");
        track.scrollLeft = drag.left - dx;
      });
      const endDrag = (event) => {
        if (!drag) return;
        const { moved, x, start } = drag;
        drag = null;
        track.classList.remove("is-dragging");
        if (!moved) return;
        const dx = event.clientX - x;
        goTo(Math.abs(dx) > track.clientWidth * 0.15 ? start + (dx < 0 ? 1 : -1) : start);
      };
      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
      show(0);
    });
    root.querySelectorAll("[data-offer-tabs]").forEach((tabs) => {
      const list = [...tabs.querySelectorAll('[role="tab"]')];
      const select = (tab, focus) => {
        list.forEach((item) => {
          const on = item === tab;
          item.setAttribute("aria-selected", String(on));
          item.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(item.getAttribute("aria-controls"));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      };
      list.forEach((tab, i) => {
        tab.addEventListener("click", () => select(tab, false));
        tab.addEventListener("keydown", (event) => {
          const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: list.length - 1 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          select(list[(keys[event.key] + list.length) % list.length], true);
        });
      });
    });
    const nav = root.querySelector("[data-offer-nav]");
    const sticky = root.querySelector("[data-offer-sticky]");
    const desktop = window.matchMedia("(min-width: 992px)");
    const state = /* @__PURE__ */ new Map();
    const setShown = (el, on) => {
      if (!el || state.get(el) === on) return;
      state.set(el, on);
      el.inert = !on;
      el.setAttribute("aria-hidden", String(!on));
    };
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      const read = scrollable > 0 ? window.scrollY / scrollable : 0;
      if (nav) {
        const opacity = desktop.matches ? Math.min(Math.max((read - 0.11) / 0.03, 0), 1) : 0;
        nav.style.opacity = desktop.matches ? String(opacity) : "";
        nav.classList.toggle("is-visible", opacity > 0);
        setShown(nav, opacity > 0);
      }
      if (sticky) {
        const on = !desktop.matches && read >= 0.3 && read <= 0.9;
        sticky.classList.toggle("is-active", on);
        setShown(sticky, on);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
    if (funnel.freeShipping) {
      root.querySelectorAll("[data-offer-chip]").forEach((chip) => {
        const free = funnel.freeShipping(Number(chip.dataset.offerChip));
        chip.textContent = free ? chip.dataset.free : chip.dataset.other;
        chip.classList.toggle("is-other", !free);
      });
    }
  }
  document.querySelectorAll("[data-offer-marquee]").forEach((marquee) => {
    marquee.addEventListener("click", () => marquee.classList.toggle("is-paused"));
  });
  document.querySelectorAll("[data-offer-faq]").forEach((faq) => {
    faq.querySelectorAll(".nappi-offer-faq__question").forEach((button) => {
      button.addEventListener("click", () => {
        const item = button.closest(".nappi-offer-faq__item");
        const open = !item.classList.contains("is-open");
        item.classList.toggle("is-open", open);
        button.setAttribute("aria-expanded", String(open));
      });
    });
  });
})();
